import React, { createContext, useMemo } from 'react';
import {
	getBrowserTimeZone,
	SYDNEY_TIMEZONE,
} from '@atlassian/jira-platform-utils-datetime/src/index.tsx';
import type { ProviderProps } from './types.tsx';

const { Provider, Consumer: TimeZoneConsumer } = createContext<string>(SYDNEY_TIMEZONE);

const TimeZoneProvider = (props: ProviderProps) => {
	const { children, value } = props;

	// Set default again if one attribute is undefined
	const memoizedValue = useMemo(() => value ?? getBrowserTimeZone(), [value]);

	return <Provider value={memoizedValue}>{children}</Provider>;
};

export { TimeZoneConsumer, TimeZoneProvider };
